import { render, staticRenderFns } from "./BaseModel.vue?vue&type=template&id=15c7461f&"
import script from "./BaseModel.vue?vue&type=script&lang=js&"
export * from "./BaseModel.vue?vue&type=script&lang=js&"
import style0 from "./BaseModel.vue?vue&type=style&index=0&id=15c7461f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports